import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-select-check-list-add',
  templateUrl: './select-check-list-add.component.html',
  styleUrls: ['./select-check-list-add.component.css']
})
export class SelectCheckListAddComponent implements OnInit {
    argType;

    argValue;

    public itemsListChecks: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }


    private async loadChecks() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListChecks = await this.datatask.Post(260, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    public async goBackToPrevious(event: { item: Item; event: MouseEvent }) {
        if (!!this.argType && !!this.argValue && event.item?.item_id) {
            const response = (await this.datatask.Post(261, {
                argtype: this.argType,
                argvalue: this.argValue,
                checklist_keyno: event.item.item_id
            }))[0];

            this.stateService?.go(response?.webpagename, response?.parms);
        }
    }

    private async init() {
        this.loadChecks();
    }

    ngOnInit() {
        this.init();
    }
}
